import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import t from "utils/locales/translation.json";

const GeolocPhotographeHeaderDsfr = (props) => {
  const { tabCategory, handleTabCategoryChange } = props;
  const { language } = useContext(LanguageContext);

  const categories = useMemo(
    () => [
      { label: t[language].geolocalisation.all, value: "all" },
      { label: t[language].geolocalisation.photographe, value: "photographe" },
      { label: t[language].geolocalisation.cabine, value: "cabine" },
    ],
    [language],
  );

  return (
    <fieldset className="fr-segmented">
      <legend className="fr-segmented__legend fr-segmented__legend--inline fr-text--lg">
        {t[language].geolocalisation.display}
      </legend>
      <div className="fr-segmented__elements">
        {categories.map((category) => {
          const { label, value } = category;
          return (
            <div className="fr-segmented__element" key={value}>
              <input
                value={value}
                checked={value === tabCategory}
                type="radio"
                id={label}
                name="photographe-filter"
                onChange={() => handleTabCategoryChange(value)}
              />
              <label className="fr-label" htmlFor={label}>
                {label}
              </label>
            </div>
          );
        })}
      </div>
    </fieldset>
  );
};

GeolocPhotographeHeaderDsfr.propTypes = {
  tabCategory: PropTypes.string.isRequired,
  handleTabCategoryChange: PropTypes.func.isRequired,
};

export default GeolocPhotographeHeaderDsfr;
